<div class="modal-header clearfix">
    <h3 class="modal-title">Expense Report Line</h3>
</div>
<div class="modal-body" *ngIf="expenseLine">
    <dx-form [formData]="expenseLine" validationGroup="expenseDialogValidationGroup">
        <dxi-item dataField="expenseDate" editorType="dxDateBox" [label]="{ text: 'Date' }" [editorOptions]="{ width: '250px' }" [disabled]="false">
            <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>
        <dxi-item [label]="{ text: 'Type' }">
            <dx-select-box [(value)]="expenseLine.expenseTypeId" [dataSource]="expenseTypes" valueExpr="id" displayExpr="name"></dx-select-box>
            <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="description"> </dxi-item>
        <dxi-item dataField="notes" editorType="dxTextArea" [editorOptions]="{ height: '100px' }"> </dxi-item>
        <dxi-item [label]="{ text: 'Amount' }">
            <div *dxTemplate>
                <dx-number-box [(value)]="expenseLine.amount" [format]="{ type: 'currency', precision: 2 }"></dx-number-box>
            </div>
            <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>

        <dxi-item itemType="group" caption="Attachments">
            <dxi-item *ngIf="attachments">
                <ul style="list-style-type: none; padding-inline-start: 0px">
                    <li *ngFor="let attachment of attachments">
                        <a title="remove" (click)="removeAttachment($event, attachment)"> <i class="fa fa-times" aria-hidden="true"></i> </a>&nbsp;
                        <a title="view" (click)="openAttachment(attachment)">{{ attachment.name }}</a>
                    </li>
                </ul>
            </dxi-item>
            <dxi-item>
                <div *dxTemplate>
                    <dx-file-uploader
                        name="fileUpload"
                        selectButtonText="Select File(s)"
                        class="attachments"
                        accept="*"
                        uploadMode="instantly"
                        [showFileList]="false"
                        [multiple]="true"
                        [uploadUrl]="uploadUrl"
                        [uploadHeaders]="uploadHeader"
                        (onUploadStarted)="uploadStarted($event)"
                        (onUploadError)="uploadError($event)"
                        (onUploaded)="uploaded($event)"
                    >
                    </dx-file-uploader>
                </div>
            </dxi-item>
        </dxi-item>
    </dx-form>
</div>

<div class="modal-footer">
    <!-- <dx-button class="btn-primary ml-1 mr-auto" (click)="takePicture()">Take Photo</dx-button> -->
    <button class="btn btn-success" (click)="save()">Save</button>
    <button class="btn btn-secondary" (click)="close()">Cancel</button>
</div>
